<template lang="pug">
.box(@click="toggle")
    h3.text-headline-medium.mt-0.mb-2 {{ item.name }}
    v-expand-transition
        p(v-show="expanded")
            span.box-desc {{ item.description }}
</template>
<script lang="ts">
export interface BoxItem {
    name: string;
    description: string;
}

export default {
    name: 'ExpandableBox',
    props: {
        item: Object as () => BoxItem,
    },
    data(): Record<string, unknown> {
        return {
            expanded: false,
        };
    },
    methods: {
        toggle(): void {
            this.expanded = !this.expanded;
        },
    },
};
</script>
<style lang="scss" scoped>
$description-padding: 15px;

.box > h3 {
    font-weight: bold;
}

.box > p {
    text-align: left;
    padding: 0;
}

.box .box-desc {
    display: block;
    padding: 0 $description-padding $description-padding $description-padding;
}
</style>
